import Seo from "../components/site/Seo";
import { PageHero, Section, CtaBand, Disclaimer } from "../components/site/Bits";
import { useSite } from "../lib/site";

export const Paras = ({ text }) => (text || "").split("\n").filter(Boolean).map((p, i) => <p key={i} className={i ? "mt-3" : ""}>{p}</p>);

export default function Funding() {
  const { content } = useSite();
  const f = content.funding || {};
  return (
    <>
      <Seo title="NDIS Funding for Assistive Technology & Home Modifications" path="/ndis-funding"
        description="How NDIS funding works for assistive technology and home modifications, plan management types, and the role of trials and quotes in funding requests." />
      <PageHero eyebrow="NDIS funding explained" title="How funding for equipment and home modifications works" intro={f.intro} />
      <Section>
        <div className="grid gap-6 lg:grid-cols-2" data-testid="funding-sections">
          {(f.sections || []).map((s) => (
            <section key={s.title} className="card p-7 text-lg">
              <h2 className="font-display text-2xl font-semibold text-teal">{s.title}</h2>
              <div className="mt-4 text-ink"><Paras text={s.body} /></div>
            </section>
          ))}
        </div>
        <div className="mt-10" data-testid="funding-disclaimer"><Disclaimer>{f.disclaimer}</Disclaimer></div>
      </Section>
      <CtaBand title="Need help with a funding request?" text="We can provide trial reports and quotes to support your NDIS request. Talk to us or your support coordinator." />
    </>
  );
}
